import CartUtil from 'common/util/CartUtil';
import ObserverUtil from 'common/util/ObserverUtil';

export default function () {
    const JsAddToCart = Component(($context) => $context.find('.js-add2cart'), ($btn) => {
        $btn.on('click', function () {

            if ($btn.hasClass('js-success')) {
                return;
            }

            const product_id = +$btn.data('product-id');
            const sku_id = +$btn.data('sku-id');
            const quantity = +$btn.data('quantity') || 1;
            const isPlus = +$btn.hasClass('js-add2cart--one-more');
            const isStatic = +$btn.hasClass('js-add2cart--static');

            if (isPlus) {
                $.ajax({
                    url: window.elkitorg_config.cart_add_url,
                    method: 'post',
                    data: {
                        product_id: product_id,
                        sku_id: sku_id,
                        quantity: 1
                    },
                    dataType: 'json'
                }).then(function () {
                    const newArguments = [arguments[0], false];

                    $(document).trigger('shop_cart_add', newArguments);
                })
            } else {
                $(document).trigger('before_add_to_cart', {product_id, sku_id});
                CartUtil.addByData({
                    product_id: product_id,
                    sku_id: sku_id,
                    quantity: quantity
                }).then(response => {
                    if (response.status === 'ok' && !isStatic) {
                        $(document).trigger('change_btn_added_to_cart', {
                            product_id,
                            sku_id,
                            item_id: response.data.item_id
                        });
                    }
                });
            }
        })
    })

    ObserverUtil.observeComponent('js-add2cart', JsAddToCart);

    $(document).on('change_btn_added_to_cart', function (e, params) {
        const {product_id, sku_id} = params;

        $('.js-add2cart').each(function () {
            const $btn = $(this);
            if (product_id === +$btn.data('product-id') && sku_id === +$btn.data('sku-id')) {
                $btn.addClass('js-success');
                $btn.attr('href', window.elkitorg_config.real_cart_url);
                $btn.find('.btn__text').html($btn.data('success-text'));
            }
        });
    });

    $(document).on('shop_cart_add', function (e, response, showModal = true) {
        if (typeof yaCounter26476791 != 'undefined') {
            yaCounter26476791.reachGoal('vkorziny');
        }

        if (showModal && !Cookies.get('isCredit')) {
            ModalUtil.openAjax(window.elkitorg_config.cart_url + '?item_id=' + response.data.item_id, undefined, undefined, function () {
                const $pages = $('.cart-page, .order-page');
                if (!$pages.length) {
                    return
                }

                if ($pages.hasClass('order-page')) {
                    $pages.trigger('remove_product');
                } else {
                    location.reload();
                }

            });
        } else if (Cookies.get('isCredit')) {
            window.location.href = window.elkitorg_config.real_cart_url;
        }
    });

    $(document).on('cart_item_deleted', function (e) {
        const $add2cartBtn = $('.to-cart__buy-btn');
        if ($add2cartBtn.length > 0 && $add2cartBtn.data('quantity-block') !== undefined) {
            $add2cartBtn.removeClass('js-success');
            $add2cartBtn.removeAttr('href');
            const $textBlock = $add2cartBtn.find('.btn__text');
            $textBlock.text($add2cartBtn.data('default-text'));
        }
    })
}

